import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tsv2-carregando',
  templateUrl: './carregando.component.html'
})
export class CarregandoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
